import { t } from "i18next";
import { toast } from "react-hot-toast";
import { ClipLoader } from "react-spinners";

import { useGetInfoBarData, useUpdateInfoBarData } from "../../apis";
import { InfoBarDataForm, InfoBarDataFormValues } from "../../components";
import { getInitialInfoBarDataFormValues } from "../../helpers";

import styles from "./InfoBar.module.scss";

const INFO_BAR_FORM_ID = "info-bar-form-id";

const InfoBar = () => {
  const { infoBarData, isLoading } = useGetInfoBarData();

  const updateInfoBarData = useUpdateInfoBarData({
    onSuccess: () => {
      toast.success(t("Info Bar updated successfully"));
    }
  });

  const handleFormSubmit = (formData: InfoBarDataFormValues) => {
    updateInfoBarData.mutate({
      freeShipping: {
        header: formData.shippingData.header,
        description: formData.shippingData.description,
        content: formData.shippingData.content
      },
      freeReturns: {
        header: formData.returnsData.header,
        description: formData.returnsData.description,
        content: formData.returnsData.content
      }
    });
  };

  return (
    <div className={styles.infoBar}>
      {!isLoading ? (
        <>
          <InfoBarDataForm
            formId={INFO_BAR_FORM_ID}
            onSubmit={handleFormSubmit}
            defaultValues={getInitialInfoBarDataFormValues(infoBarData)}
            isLoadingUpdate={updateInfoBarData.isLoading}
          />
        </>
      ) : (
        <div className={styles.infoBar_loader}>
          <ClipLoader size={50} color="#fb3973" />
        </div>
      )}
    </div>
  );
};

export default InfoBar;
